module.exports = require("@swa-ui/vacations/src/VacationsBookingWidget/VacationsBookingWidget.module.scss");